import { t } from "i18next";
import { Link, useLocation } from "react-router-dom";
import LanguageSelect from "./LanguageSelect";
import { useState } from "react";
import AuthContext from "../context/AuthContext";
import { useContextSelector } from "use-context-selector";
import { isEmpty } from "lodash";

const BottomNavigation = () => {
  const [language, setLanguage] = useState(false);
  const user = useContextSelector(AuthContext, (ctx) => {
    return ctx.user;
  });
  const setSidebarModal = useContextSelector(AuthContext, (ctx) => {
    return ctx.setSidebarModal;
  });
  const setSidebarModalAccount = useContextSelector(AuthContext, (ctx) => {
    return ctx.setSidebarModalAccount;
  });
  
  let object = {
    "/": "11px",
    "/promotions": "107px",
    "/wallet/deposit": "155px",
    "/account": "299px",
  };

  const location = useLocation();
  return !isEmpty(user) ? (
    <div
      _ngcontent-serverapp-c4147462186
      className="toolbar toolbar-inner"
      onMouseDown={(e) => e.stopPropagation()}
    >
      <ul _ngcontent-serverapp-c4147462186 style={{ "--slider-x": "11px" }}>
        <li
          _ngcontent-serverapp-c4147462186
          className={`ng-star-inserted ${location.pathname == "/" ? "active" : ""}`}
        >
          <Link to="/" _ngcontent-serverapp-c4147462186>
            <span _ngcontent-serverapp-c4147462186 className="icon-wrap">
              <span
                _ngcontent-serverapp-c4147462186
                className="item-icon"
                style={{
                  "mask-image":
                    'url("/assets/Other/icon-home.webp?v=1772072361392")',
                }}
              />
            </span>
            <p _ngcontent-serverapp-c4147462186>{t("Home")}</p>
          </Link>
        </li>
        <li
          _ngcontent-serverapp-c4147462186
          className={`ng-star-inserted ${location.pathname == "/promotions" ? "active" : ""}`}
        >
          <Link to="/promotions" _ngcontent-serverapp-c4147462186>
            <span _ngcontent-serverapp-c4147462186 className="icon-wrap">
              <span
                _ngcontent-serverapp-c4147462186
                className="item-icon"
                style={{
                  "mask-image":
                    'url("/assets/Other/icon-promotion.webp?v=1772072361392")',
                }}
              />
            </span>
            <p _ngcontent-serverapp-c4147462186>{t("PROMOITIONS")}</p>
          </Link>
        </li>
        <li
          _ngcontent-serverapp-c4147462186
          className={`ng-star-inserted ${location.pathname == "/wallet/deposit" ? "active" : ""}`}
        >
          <Link to="/wallet/deposit" _ngcontent-serverapp-c4147462186>
            <span _ngcontent-serverapp-c4147462186 className="icon-wrap">
              <span
                _ngcontent-serverapp-c4147462186
                className="item-icon"
                style={{
                  "mask-image":
                    'url("/assets/Other/icon-deposit.webp?v=1772072361392")',
                }}
              />
            </span>
            <p _ngcontent-serverapp-c4147462186>{t("Deposit")}</p>
          </Link>
        </li>
        <li
          _ngcontent-serverapp-c4147462186
          className={`ng-star-inserted ${location.pathname == "/account" ? "active" : ""}`}
        >
          <Link
            to={null}
            onClick={(e) => {
              e.preventDefault();
              setSidebarModalAccount(true);
            }}
            _ngcontent-serverapp-c4147462186
          >
            <span _ngcontent-serverapp-c4147462186 className="icon-wrap">
              <span
                _ngcontent-serverapp-c4147462186
                className="item-icon"
                style={{
                  "mask-image":
                    'url("/assets/Other/icon-info.webp?v=1772072361392")',
                }}
              />
            </span>
            <p _ngcontent-serverapp-c4147462186>{t("MyAccount")}</p>
          </Link>
        </li>
        {!isEmpty(object[location?.pathname]) && (
          <span
            _ngcontent-serverapp-c4147462186
            aria-hidden="true"
            className="toolbar-border ng-star-inserted"
            style={{
              transform: `translate3d(${object[location.pathname]}, 0px, 0px)`,
            }}
          />
        )}
      </ul>
    </div>
  ) : (
    <div
      _ngcontent-serverapp-c3842177949
      className="toolbar beforelogin havelanguage ng-star-inserted"
    >
      <div
        onClick={() => setLanguage(true)}
        _ngcontent-serverapp-c3842177949
        className="language-select order-null ng-star-inserted"
      >
        <img
          _ngcontent-serverapp-c3842177949
          width={60}
          height={60}
          alt="BD"
          src="/assets/Other/BD.png"
        />
        <p _ngcontent-serverapp-c3842177949>
          BDT <br _ngcontent-serverapp-c3842177949 />
          {t("English")}{" "}
        </p>
      </div>

      <div
        _ngcontent-serverapp-c3842177949
        className="register-button order-null"
      >
        <Link
          _ngcontent-serverapp-c3842177949
          to="/register"
          className="ng-star-inserted"
        >
          {" "}
          {t("Singup")}
        </Link>
      </div>
      <div _ngcontent-serverapp-c3842177949 className="login-button order-null">
        <Link
          _ngcontent-serverapp-c3842177949
          to="/login"
          className="ng-star-inserted"
        >
          {" "}
          {t("Login")}
        </Link>
      </div>
      {language && <LanguageSelect setLanguage={setLanguage} />}
    </div>
  );
};

export default BottomNavigation;
